import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CropSteeringP0 } from '../../Images/crop_steering_v2_p0.svg';
import { ReactComponent as CropSteeringP1 } from '../../Images/crop_steering_v2_p1.svg';
import { ReactComponent as CropSteeringP2 } from '../../Images/crop_steering_v2_p2.svg';
import { ReactComponent as CropSteeringP3 } from '../../Images/crop_steering_v2_p3.svg';
import { ExpandableSettingsGroupGrid, ValueBox } from '../../FormWidgets/SettingGroup';
import Desc from '../../FormWidgets/Description';
import { EventGapSelect } from '../../FormWidgets/Select';

const phaseLabels = ['phase_0_activation', 'phase_1_ramp_up', 'phase_2_maintain', 'phase_3_drydown'];
const phaseGraphs = [CropSteeringP0, CropSteeringP1, CropSteeringP2, CropSteeringP3];
const useStyles = makeStyles((theme) => ({
  cropSteering: {
    marginLeft: '0.5%',
    [theme.breakpoints.down('sm')]: { width: '100%' },
    [theme.breakpoints.up('md')]: { width: '200%' }
  }
}));

// Both editors use the same phase layout; the caller owns which controls are editable.
export default function IrrigationPhaseSettings({ phase, expandId, children }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const Graph = phaseGraphs[phase];
  return (
    <ExpandableSettingsGroupGrid expand_id={expandId} label={phaseLabels[phase]}>
      <Graph className={classes.cropSteering} role="img" aria-label={t(phaseLabels[phase])} />
      <></>
      {children}
    </ExpandableSettingsGroupGrid>
  );
}

export function IrrigationMoreSettings({ expandId, children }) {
  return (
    <ExpandableSettingsGroupGrid expand_id={expandId} label="more" outside={true}>
      {children}
    </ExpandableSettingsGroupGrid>
  );
}

export function IrrigationReferenceInterval({ value, disabled, onChange, marker, controls, settingPath }) {
  const { t } = useTranslation();
  return (
    <ValueBox>
      <Typography gutterBottom>
        {marker}
        <Desc id="irrigation_p1_auto_vwc_exec_gap_days" />
      </Typography>
      <EventGapSelect
        controls={controls}
        settingPath={settingPath}
        unsaved={controls?.hasChanged(settingPath)}
        maxDays={10}
        value={value ?? 0}
        disabled={disabled}
        inputProps={{ 'aria-label': t('irrigation_p1_auto_vwc_exec_gap_days') }}
        onChange={onChange}
      />
    </ValueBox>
  );
}
